import { useTheme } from 'foundations-theming/utils';
import { useMemo } from 'react';

/**
 * Calculates the height of a drop shadow based on the theme's box shadow value.
 * If the shadow theme is not found or parsing fails, it returns a fallback value.
 *
 */
export const useBoxShadowHeight = (shadowTheme, fallback) => {
  const theme = useTheme();
  return useMemo(() => {
    try {
      const parts = theme.boxShadow[shadowTheme].split(/\s+/);
      const offsetY = parseFloat(parts[1]);
      const blur = parseFloat(parts[2]);
      if (!isNaN(offsetY) && !isNaN(blur)) {
        return Math.ceil(Math.abs(offsetY) + blur);
      }
    } catch (_unused) {
      // Proceed to fallback
    }
    return fallback;
  }, [shadowTheme, fallback, theme.boxShadow]);
};